import identity from "lodash/fp/identity";

class RedirectorPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default RedirectorPageTransform;



// WEBPACK FOOTER //
// ./src/pages/redirector/redirector.transforms.js